import { injectGlobal } from 'styled-components';
import fontKomika from './fonts/komikax_-webfont.woff';
import fontKomika2 from './fonts/komikax_-webfont.woff2';
import sfRegular from './fonts/SFProDisplay-Regular.woff';
import sfRegular2 from './fonts/SFProDisplay-Regular.woff2';
import sfMedium from './fonts/SFProDisplay-Medium.woff';
import sfMedium2 from './fonts/SFProDisplay-Medium.woff2';
import sfSemibold from './fonts/SFProDisplay-Semibold.woff';
import sfSemibold2 from './fonts/SFProDisplay-Semibold.woff2';
import sfLight from './fonts/SFProDisplay-Light.woff';
import sfLight2 from './fonts/SFProDisplay-Light.woff2';

/* eslint no-unused-expressions: 0 */
injectGlobal` 
  @font-face {
      font-family: "gunnarrough";
      src: url("fonts/gunnar-rough.woff2") format("woff2"),
          url("fonts/gunnar-rough.woff") format("woff");
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
    font-family: 'komika_axisregular';
    src: url(${fontKomika2}) format('woff2'),
         url(${fontKomika}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'apercuregular';
    src: url('fonts/apercu_regular-webfont.woff2') format('woff2'),
         url('fonts/apercu_regular-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'SF-Light';
    src: url(${sfLight2}) format('woff2'),
         url(${sfLight}) format('woff');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'SF-Regular';
    src: url(${sfRegular2}) format('woff2'),
         url(${sfRegular}) format('woff');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'SF-Medium';
    src: url(${sfMedium2}) format('woff2'),
         url(${sfMedium}) format('woff');
    font-weight: 600;
    font-style: normal;
  }
  @font-face {
    font-family: 'SF-Semibold';
    src: url(${sfSemibold2}) format('woff2'),
         url(${sfSemibold}) format('woff');
    font-weight: 600;
    font-style: normal;
  }

  html {
    -webkit-tap-highlight-color: transparent;
  }

  body {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust:100%;
    -ms-text-size-adjust:100%;
    height: 100%;
    width: 100%;
  }

  .app {
    background-color: #fff;
    min-height: 100%;
    min-width: 100%;
    font-size: 10px;
    font-family: 'Raleway', sans-serif;
    color: #333;

    h1, h2, h3, h4, h5, h6, p {
      margin: 0;
      color: inherit;

    }

    a {
      text-decoration: none;
      color: inherit;
    }
  }


  :focus {
    outline: none;
  }
  .ant-message {
    font-size: 16px!important;
  }
  #icc-container {
    z-index: 9999;
  }
  .ant-tooltip {
    font-size: 14px!important;
  }
`;



// WEBPACK FOOTER //
// ./src/themes/global.js